import React from "react"
import { MoreHorizontal, Share, Pencil, Trash2 } from "lucide-react"
import { toast } from "sonner"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

interface DesignOptionsMenuProps {
  designId: string
  designName: string
  generatedImageUrl: string
  onRename: (designId: string) => void
  onDelete: (designId: string) => void
}

export function DesignOptionsMenu({
  designId,
  designName,
  generatedImageUrl,
  onRename,
  onDelete
}: DesignOptionsMenuProps) {
  
  const handleShare = () => {
    // Copy image URL to clipboard
    navigator.clipboard.writeText(generatedImageUrl)
      .then(() => {
        toast.success("Image URL copied to clipboard", {
          duration: 3000
        })
      })
      .catch(err => {
        console.error("Failed to copy URL:", err)
        toast.error("Failed to copy image URL", {
          duration: 3000
        })
      })
  }
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="focus:outline-none">
          <MoreHorizontal className="h-5 w-5 text-gray-600 cursor-pointer hover:text-gray-800" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleShare}>
          <Share className="mr-2 h-4 w-4" />
          <span>Share</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onRename(designId)}>
          <Pencil className="mr-2 h-4 w-4" />
          <span>Rename</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => onDelete(designId)}
          className="text-red-600 focus:text-red-600"
        >
          <Trash2 className="mr-2 h-4 w-4" />
          <span>Delete</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}